import React from 'react';
import { Box, Card, CardContent, Chip, Grid, Typography, CircularProgress } from '@material-ui/core';
import { WhatsAppWalletType } from 'api/whatsapp/types';
import { IApiState } from 'store/types';
import { apiStatus } from 'shared/constants/AppEnum';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            borderRadius: 12,
        },
        balanceLabel: {
            color: theme.palette.text.secondary,
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: 1,
        },
        balanceValue: {
            fontSize: 28,
            fontWeight: 700,
        },
        subBalance: {
            fontSize: 18,
            fontWeight: 600,
        },
        statusChip: {
            marginLeft: theme.spacing(1),
        },
        lowBalanceWarning: {
            marginTop: theme.spacing(1),
            color: theme.palette.error.main,
            fontWeight: 600,
            fontSize: 13,
        },
    })
);

interface WalletCardProps {
    wallet: WhatsAppWalletType | null;
    api: IApiState;
}

const WalletCard: React.FC<WalletCardProps> = ({ wallet, api }) => {
    const classes = useStyles();

    if (api.status === apiStatus.LOADING) {
        return (
            <Card className={classes.card}>
                <CardContent>
                    <Box display="flex" justifyContent="center" alignItems="center" py={4}>
                        <CircularProgress />
                    </Box>
                </CardContent>
            </Card>
        );
    }

    if (!wallet) {
        return (
            <Card className={classes.card}>
                <CardContent>
                    <Typography color="textSecondary">No wallet data available</Typography>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card className={classes.card}>
            <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                    <Typography variant="h6">WhatsApp Wallet</Typography>
                    <Chip
                        className={classes.statusChip}
                        label={wallet.is_active ? 'Active' : 'Inactive'}
                        color={wallet.is_active ? 'primary' : 'default'}
                        size="small"
                    />
                </Box>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Typography className={classes.balanceLabel}>Total Balance</Typography>
                        <Typography className={classes.balanceValue}>{wallet.total_balance}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography className={classes.balanceLabel}>Transactional</Typography>
                        <Typography className={classes.subBalance}>{wallet.transactional_balance}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography className={classes.balanceLabel}>Promotional</Typography>
                        <Typography className={classes.subBalance}>{wallet.promotional_balance}</Typography>
                    </Grid>
                </Grid>
                {wallet.is_low_balance && (
                    <Typography className={classes.lowBalanceWarning}>
                        ⚠ Low balance! Threshold: {wallet.low_balance_threshold}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default WalletCard;
